/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var fwd = {
    // All pages
    common: {
      init: function() {

        // Mobile Nav
        // ====================================

        var isTriggerActive = false;
        var $mobileNav = $('.c-mobile-nav');
        var $mobileTrigger = $('.js-mobile-nav-trigger');
        var $pageHeader = $('.js-page-header');

        $mobileTrigger.on('click', function(event) {
          event.preventDefault();

          isTriggerActive = !isTriggerActive;
          $mobileNav.toggleClass('is-open');
          $pageHeader.toggleClass('is-active');
          $(this).toggleClass('is-active');
          $('html').toggleClass('is-locked');

          if (isTriggerActive) {
            disableBodyScroll(true, '.c-mobile-nav__inner');
          } else {
            disableBodyScroll(false, '.c-mobile-nav__inner');
          }
        });

        // Header
        // ====================================

        checkPosition();
        $(window).scroll(_.throttle(checkPosition, 250));

        // Slider
        // ====================================;

        $(".swiper-container").each(function(index, element) {
          var $this = $(this);
          $this.addClass("instance-" + index);
          $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
          $this.find(".swiper-button-next").addClass("btn-next-" + index);
          $this.find(".swiper-pagination").addClass("pagina" + index);
          var swiper = new Swiper(".instance-" + index, {
            nextButton: $this.find(".swiper-button-next")[0],
            prevButton: $this.find(".swiper-button-prev")[0],
            pagination: $this.find(".swiper-pagination")[0],
            loop: true,
            paginationClickable: true,
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazyLoading: true,
          });

          // Disable scrolling if only one item.
          // Needs to be 3 because of loop: true that creates 2 extra slides
          if (swiper.slides.length == 3) {
            swiper.lockSwipes();
          }
        });

        // Case studies
        // ====================================
        // Calculate padding and positioning of the overlapping intro section
        introSection();
        $(window).smartresize(introSection);

      }
    },
    // Home page
    home: {
      init: function() {

        /*
        Custom Homepage Animation
        Created by @tdwyerdesign / tjd@tristandwyer.com
        Initial Implementation - 10/10/17
        */

        /* ====================================================
        General Setup and Vars
        ==================================================== */

        var curState = 0; // Determine where we are
        var slideTime = 3000;

        // Define our animatable elements
        var aniTitle = document.getElementById('home-animation-title');
        var marketTitles = [
          document.getElementById('market-title-0'),
          document.getElementById('market-title-1'),
          document.getElementById('market-title-2'),
          document.getElementById('market-title-3')
        ];
        var marketIcons = [
          document.getElementById('market-icon-0'),
          document.getElementById('market-icon-1'),
          document.getElementById('market-icon-2'),
          document.getElementById('market-icon-3')
        ];

      /* ====================================================
      Set everything up
      ==================================================== */


        function animateTitle() {
          $(aniTitle).addClass('active');
        }

        // Loop through our slides
        function animateNext() {

          if (curState != 0) {
            $(marketTitles[curState - 1]).addClass('done');
            $(marketIcons[curState - 1]).addClass('done');
          }

          $(marketTitles[curState]).addClass('active');
          $(marketIcons[curState]).addClass('active');

          strokeUpIcons(curState);

          curState++;
        }

        function strokeUpIcons(target) {

          var strokeTime = 1500;
          var strokeTimeShort = 1000;

          if (target == 0) {
            animateSVG("#lifesciences", "#atom", strokeTime, 500, "fadeColorOn");
            animateSVG("#lifesciences", "#circle1", strokeTime, 600, "fadeColorOn");
            animateSVG("#lifesciences", "#circle2", strokeTime, 700, "fadeColorOn");
            animateSVG("#lifesciences", "#arm1", strokeTime, 800, "hollow");
            animateSVG("#lifesciences", "#arm2", strokeTime, 900, "hollow");
            animateSVG("#lifesciences", "#arrow", strokeTime, 900, "hollow");

          } else if (target == 1) {
            animateSVG("#financial", "#pie1", strokeTime, 500, "fadeColorOn");
            animateSVG("#financial", "#pie2", strokeTime, 600, "fadeColorOn");
            animateSVG("#financial", "#pie3", strokeTime, 700, "fadeColorOn");

            animateSVG("#bars", "#bar1", strokeTimeShort, 500, "hollow");
            animateSVG("#bars", "#bar2", strokeTimeShort, 500 + 100, "hollow");
            animateSVG("#bars", "#bar3", strokeTimeShort, 500 + 200, "hollow");
            animateSVG("#bars", "#bar4", strokeTimeShort, 500 + 300, "hollow");
            animateSVG("#bars", "#bar5", strokeTimeShort, 500 + 400, "hollow");
            animateSVG("#bars", "#bar6", strokeTimeShort, 500 + 500, "hollow");
            animateSVG("#bars", "#bar7", strokeTimeShort, 500 + 600, "hollow");
            animateSVG("#bars", "#bar8", strokeTimeShort, 500 + 700, "hollow");
            animateSVG("#bars", "#bar9", strokeTimeShort, 500 + 800, "hollow");

          } else if (target == 2) {
            animateSVG("#healthcare", "#heart", strokeTime, 400, "fadeColorOn");
            animateSVG("#healthcare", "#heartbeat", strokeTimeShort, 1000, "hollow");
            animateSVG("#healthcare", "#eyebrow", strokeTimeShort, 700, "hollow");
          }
        }

        // Reusable SVG Animation Function
        function animateSVG(dashedId, pathId, time, delay, fill) {

          var dashedSvg = Snap.select(dashedId),
            dashedPath = dashedSvg.select(pathId);

          var totalLength = Snap.path.getTotalLength(dashedPath.attr("d"));

          dashedPath.attr({
            'stroke-dashoffset': totalLength,
            'stroke-dasharray': totalLength
          });

          setTimeout(function() {
            // Animate our strokes
            Snap.animate(totalLength, 0, function(value) {
              dashedPath.attr({ 'stroke-dashoffset': value });
            }, time, mina.easeinout);
            // Animate our fils
            Snap.animate(totalLength, 0, function(value) {
              dashedPath.attr({ class: fill });
            }, time, mina.easeinout);

          }, delay);
        }

        // Create a timer to loop through our slides
        function startAniTimer() {
          var aniTimer = setInterval(function() {

            if (curState < marketTitles.length) {
              animateNext();

            } else {
              //console.log("we're done");
              clearInterval(aniTimer);
            }

          }, slideTime);
        }

        // Kickstart animation
        function init() {
          animateTitle();
          animateNext();
          startAniTimer();
        }
        setTimeout(init, 500);

      }
    },

    // Case studies page
    case_study: {
      init: function() {}
    },

    // About
    about: {
      init: function() {

        // Team
        // ====================================

        $('.js-team-modal').modaal({
          width: 550,
          hide_close: true
        });

        $('.js-team-modal-close').on('click', function(event) {
          event.preventDefault();
          $('.js-team-modal').modaal('close');
        });

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var namespace = fwd;
      funcname = (funcname === undefined) ? 'init' : funcname;
      if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
      });
    }
  };

  $(document).ready(UTIL.loadEvents);

  // Check if page is scrolling
  function checkPosition() {
    var header = $('.js-page-header');
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
      header.addClass('is-scrolling');
    } else {
      header.removeClass('is-scrolling');
    }
  }

  // Position case studies intro section and following section
  function introSection() {
    var introBoxHeight = $('.c-case-study-intro').outerHeight();
    var $section = $(".c-case-study-intro");
    var $sectionPad = $('.c-case-study-section:nth-of-type(2)');

    if ($section.css("position") == "absolute") {
      $sectionPad.css({ "padding-top": (introBoxHeight / 2) });
    } else {
      $sectionPad.css({ "padding-top": "0" });
    }
  }

})(jQuery); // Fully reference jQuery after this point.
